import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { Body } from '../typography/Body';
import { Heading } from '../typography/Heading';
import { FlexContainer } from './FlexContainer';
export interface BreadcrumbSegment {
  label: string;
  href?: string;
}
export interface PageBreadcrumbProps {
  segments: BreadcrumbSegment[];
  title?: string;
  /**
   * Rendered in the final (title) position instead of the title heading — e.g. a
   * section selector dropdown. Produces `Segment / Segment / [slot]`.
   */
  titleSlot?: React.ReactNode;
}
export function PageBreadcrumb(t0) {
  const $ = _c(8);
  const {
    segments,
    title,
    titleSlot
  } = t0;
  let t1;
  if ($[0] !== segments) {
    t1 = segments.map(_temp);
    $[0] = segments;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== title || $[3] !== titleSlot) {
    t2 = titleSlot ?? <Heading size="md">{title}</Heading>;
    $[2] = title;
    $[3] = titleSlot;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t1 || $[6] !== t2) {
    t3 = <FlexContainer className="gap-2" items="baseline">{t1}{t2}</FlexContainer>;
    $[5] = t1;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}
function _temp(segment) {
  return <FlexContainer className="gap-2" items="baseline" key={segment.label}>{segment.href ? <Link className="hover:underline" href={segment.href}><Heading className="text-content-secondary" size="md">{segment.label}</Heading></Link> : <Heading className="text-content-secondary" size="md">{segment.label}</Heading>}<Body className="text-content-tertiary" size="md">/</Body></FlexContainer>;
}